import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaMoneyBillAlt, FaRegSadTear, FaInbox } from "react-icons/fa";
import GlobalLoading from '../components/GlobalLoading';
import {useNavigate} from 'react-router-dom';
import "../styles/transact.css";

const TransactDesign = () => {
    const { getTransactions, fetchBankAccounts, setSelectedTransaction } = useContext(AuthContext);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            const response = await getTransactions();
            console.log("RAW RESPONSE:", response);
            console.log("Sorted transactions:", response.transactions);
            console.log("Grouped by date:", groupByDate(response.transactions));
            if (response.error) {
                setError(response.error);
            } else {
                const sorted = [...(response.transactions || [])].sort(
                    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                );
                setTransactions(sorted);
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    
        useEffect(() => {
            const loadAccounts = async () => {
                const result = await fetchBankAccounts();
                 console.log("RAW RESPONSE:", result);
                console.log("Sorted transactions:", result.bankAccounts);
                if (!result.error) {
                    setBankAccounts(result.bankAccounts);
                } else {
                    console.error(result.error);
                }
            };
    
            loadAccounts();
        }, [fetchBankAccounts]);
    

    const groupByDate = (txs) => {
        return txs.reduce((acc, tx) => {
            const rawDate = new Date(tx.timestamp);
            if (isNaN(rawDate)) {
                console.warn("Invalid timestamp:", tx.timestamp); // catch format issues
                return acc; // skip this transaction
            }

            // Normalize to "YYYY-MM-DD" to ensure consistent grouping
            const dateKey = rawDate.toLocaleDateString("en-CA"); // e.g., "2025-06-09"

            if (!acc[dateKey]) acc[dateKey] = [];
            acc[dateKey].push(tx);
            return acc;
        }, {});
    };

    if (loading) return <GlobalLoading />
    if (error) return <p className="error">{error}</p>;

    const grouped = groupByDate(transactions);
const getDescription = (tx) => {
    // Match ONLY from saved bankAccounts
    const matchingAccount = bankAccounts.find(
        (account) =>
            account.accountNumber === tx.accountNumber ||
            account.accountName === tx.accountName

    );

    const resolvedBankName = matchingAccount?.bankName?.toUpperCase() || "UNKNOWN BANK";
    const resolvedAccountName = matchingAccount?.accountName?.toUpperCase() || tx.accountName || "UNKNOWN ACCOUNT";
 
        switch (tx.type) {
            case "buy-airtime":
                return `AIRTIME ${tx.network?.toUpperCase() || ""} ${tx.phoneNumber || ""}`;
            case "generate-epin":
                return `EPIN ${tx.network || ""} ₦${tx.denomination} x${tx.quantity}`;
            case "buy-data":
               return `DATA ${tx.network?.toUpperCase() || ""} ${tx.phoneNumber || ""}`;
            case "buy-cabletv":
                return `CABLE ${tx.service_id?.toUpperCase() || ""} ${tx.smartcard_number || ""}`;
            case "deposit":
                return `WALLET FUNDING`;
            case "withdrawal":
                return `WITHDRAWAL TO ${resolvedBankName} FROM ${resolvedAccountName}`;
            case "buy-education":
                return `${tx.package?.toUpperCase() || ""}`;
            case "pay-electricity":
                return `ELECTRICITY ${tx.service?.toUpperCase() || ""} ${tx.meterNumber || ""} ${tx.meterType?.toUpperCase() || ""} `;
            case "airtime-to-cash":
                return `AIRTIME TO CASH`;
            case "bulk-sms":
                return `BULK SMS FROM ${tx.sender?.toUpperCase() || ""}`;
            case "Approved":
                return `APPROVED`;
            default:
                return `TRANSACTION`;
        }
    };

    return (
    <div className="mobile-transactions-container">
        {transactions.length === 0 ? (
            <div className="no-transactions-message">
                <FaRegSadTear className="no-transactions-icon" />
                <p>No transaction record</p>
            </div>
        ) : (
            Object.keys(grouped).map((date) => (
                <div key={date} className="transaction-day-group">
                    <h4 className="transaction-date-header">
                        {new Date(date).toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                            weekday: "long",
                        }).toUpperCase()}
                    </h4>
                    {grouped[date].map((tx) => (
                        <div
                            key={tx._id}
                            className="transaction-card"
                            onClick={() => navigate(`/transactions/${tx._id}`)}
                        >
                            <div className="transaction-icon-row">
                                <FaMoneyBillAlt className="transaction-icon" />
                            </div>
                            <div className="transaction-desc-row">
                                {tx.description || getDescription(tx)}
                            </div>
                            <div className={`transaction-amount-row ${
                                (tx.status === "Successful" || tx.status === "success") &&
                                (
                                    tx.type === "deposit" ||
                                    tx.type === "airtime-to-cash" ||
                                    tx.type === "Approved"
                                )
                                    ? "credit"
                                    : "debit"
                            }`}>
                                ₦{Number(tx.amount).toLocaleString()}
                            </div>
                        </div>
                    ))}
                </div>
            ))
        )}
    </div>
);

};

export default TransactDesign;
